var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTakeLpToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0BC196",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M22.8 22.2c-2.2 0-2.2 2.2-4.3 2.2-2.2 0-2.2-2.2-4.4-2.2-2.1 0-2.1 2.2-4.3 2.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0EF1BC",
    strokeWidth: 2,
    d: "M21.7 11.6a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A0F7E6",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16.3 9.5v4.3m-2.2-2.2h4.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeLpToken);
export default __webpack_public_path__ + "static/media/Take LP Token.046967210910e9e8abd1aa9a32c1df40.svg";
export { ForwardRef as ReactComponent };